export class ResultDTO{
  constructor(public code: number, public description: string) {
  }
}
